import { createTheme } from './theme';

// Figma link: https://www.figma.com/file/PpGD0nFb29bV6Ilx8Ln1GQ/LT--new-design?node-id=125%3A7616

export const lightTheme = createTheme({
  palette: {
    grey: {
      '200': '#F9F9F9',
      '300': '#EFF0F6',
      '400': '#D9DBE9',
      '500': '#DCDDDE',
      '600': '#A0A3BD',
      '700': '#6E7191',
    },
    yellow: {
      '50': '#FFF9E6',
      '500': '#FEBA00',
    },
    ocean: {
      '700': '#0095CC',
    },
    cool: {
      '700': '#4E4B66',
    },
    base: {
      '100': '#FFFFFF',
      '900': '#000000',
    },
    primary: {
      '50': '#FEEAE6',
      '100': '#FCD4CC',
      '300': '#F67F66',
      '400': '#C33E28',
      '600': '#F02A00',
    },
    success: {
      '50': '#F2FFF9',
      '100': '#00FE80',
      '400': '#00CC67',
      '500': '#00994D',
    },
    error: {
      '50': '#FFEBEA',
      '200': '#FF675F',
      '300': '#F12705',
    },
    warning: {
      '100': '#FEFAF1',
      '200': '#FBF3E2',
      '300': '#F3D9A5',
      '400': '#E2A21F',
      '700': '#5A400C',
    },
  },
});
